import { render } from "./ProdukData.vue?vue&type=template&id=17874a80"
import script from "./ProdukData.vue?vue&type=script&lang=js"
export * from "./ProdukData.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__